<template>
    <div>
        <section class="vip-day-wrap isvipday-banner-wrap">
            <img src="../images/index-vip-banner-title-1.png" class="vip-banner-title">
            <div class="vip-countdown" id="vip-countdown" :data-count="countDown()">
                <span>{{zeroTime(hour)}}</span>
                <b>:</b>
                <span>{{zeroTime(minute)}}</span>
                <b>:</b>
                <span>{{zeroTime(second)}}</span>
            </div>
        </section>
        <div class="vip-start-page isvipday-start-page" :class="startAnamiton" :style="{display:vipStartBox==1?'none':'black'}">
            <div class="start-top">
                <span class="start-page-countdown" @click.stop="closeVipStartPage"><i>跳过</i><b v-text="vipStartCount+'s'">5s</b></span>
                <img class="start-title" src="../images/vip-start-title-1.png">
                <img class="start-right-line" src="../images/right.png">
                <img class="start-left-line" src="../images/left.png">
            </div>
            <div class="start-bottom">
                <img class="start-info" src="../images/vip-start-info.png">
                <img class="start-btn" src="../images/vip-start-btn.png" @click.stop="closeVipStartPage">
            </div>
        </div>
    </div>
</template>

<script>
    import {getCookie,setCookie} from '@/resource/js/common'

    export default{
        data(){
            return {
                second:0,
                minute:0,
                hour:0,
                endTime:this.endTimeV,
                vipStartBox:0,
                vipStartCount:4,
                startAnamiton:''
            }
        },
        props:['endTimeV','vipLevel'],
        mounted(){
            if (getCookie('vipPageStart') == 1) {
                this.$data.vipStartBox = 1;
            } else {
                setCookie('vipPageStart', 1,true);
                this.$data.startAnamiton = 'start-animation';
            }
            this.vipStartCountdown();
        },
        methods:{
            vipStartCountdown: function () {
                var that = this;
                var count = 4;
                var int = setInterval(function () {
                    count--;
                    that.$data.vipStartCount = count;
                    if (count <= 3) {
                        that.$data.startAnamiton = 'start-animation';
                        if (count <= 0) {
                            clearInterval(int);
                            that.$data.vipStartBox = 1;
                        }
                    }
                }, 1000);
            },
            countDown(){
                var that = this;
                let nowDate = new Date();
                let seconds = this.endTime/1000-nowDate.getTime()/1000;

                var int = window.setInterval(function () {
                    var hour = Math.floor(seconds / 3600);
                    var minute = Math.floor((seconds - hour * 3600) / 60);
                    var second = Math.floor(seconds - hour * 3600 - minute * 60);
                    if (seconds <= 0) {
                        clearInterval(int);
                        hour = 0;
                        minute = 0;
                        second = 0;

                    } else {
                        seconds--;
                    }

                    that.hour = hour;
                    that.minute = minute;
                    that.second = second;
                }, 1000);
            },
            zeroTime: function (item) {//时间显示处理
                return parseInt(item) < 10 ? '0' + item : item;
            },
            vipProTips(){
                let _this = this;
                this.$prompt('您的当前会员等级：V'+_this.vipLevel+'<br/>买买买升到相应等级，可以购买噢！')
            },
            closeVipStartPage(){

            }
        }

    }
</script>

<style lang="scss" rel="stylesheet/scss">
    @import "../../../resource/css/color";
    .vip-day-wrap {
        position: relative;
        width: 7.5rem;
        height: 5.09rem;
        margin: 0 auto -2.46rem;
        background: url("../images/index-vip-banner.jpg") top center no-repeat;
        background-size: 100% 5.09rem;
        padding-top: .44rem;
        box-sizing: border-box;
        .vip-banner-title {
            width: 2.36rem;
            display: block;
            margin: 0 auto;
        }

        .isvipday-banner-wrap {
            display: block;
        }

        .vip-countdown {
            position: absolute;
            top: 2.2rem;
            left: 50%;
            -webkit-transform: translateX(-50%);
            display: -webkit-box;
            color: #f4eda6;
        }

        .vip-countdown span {
            display: block;
            width: .46rem;
            height: .4rem;
            border: 1px solid #f4eda6;
            color: #f4eda6;
            border-radius: .1rem;
            text-align: center;
            line-height: .4rem;
            margin: 0 .1rem;
        }

        .vip-countdown b {
            font-weight: normal;
            display: block;
            line-height: .4rem;
        }
    }
    /*vip开屏*/
    .isvipday-body {
        display: none;
    }

    .vip-start-page {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 99999;
        /*display: none;*/
        .start-bg {
            position: absolute;
            top: 10%;
            left: 0;
        }

        .start-bg img {
            width: 100%;
            display: block;
        }

        .start-top {
            display: none;
            position: relative;
            width: 100%;
            height: 50%;
            background: #ff4f57 url("../images/vip-start-bg-top.jpg") center bottom no-repeat;
            background-size: 100% 100%;
        }

        .start-bottom {
            display: none;
            position: relative;
            width: 100%;
            height: 50%;
            background: #ff4f57 url("../images/vip-start-bg-bottom.jpg") center top no-repeat;
            background-size: 100% 100%;
        }

        .start-page-countdown {
            position: absolute;
            top: .24rem;
            right: .24rem;
            display: block;
            width: 1.08rem;
            height: .93rem;
            background: url("../images/vip-start-countdown.png") top right no-repeat;
            background-size: 1.08rem .93rem;
            font-size: .24rem;
            text-align: center;
        }

        .start-page-countdown i {
            color: #ffffff;
            display: block;
            font-style: normal;
            margin-top: .15rem;
            line-height: .3rem;
        }

        .start-page-countdown b {
            color: #ffebb5;
            font-size: .26rem;
            display: block;
            font-weight: normal;
        }

        .start-title {
            width: 3.06rem;
            height: auto;
            display: block;
            position: absolute;
            left: 50%;
            margin-left: -1.53rem;
            bottom: 1rem;
        }

        .start-left-line, .start-right-line {
            width: 1.9rem;
            display: block;
            position: absolute;
            top: 5.2rem;
        }

        .start-left-line {
            left: 0;
        }

        .start-right-line {
            right: 0;
        }

        .start-info {
            width: 5.74rem;
            display: block;
            position: absolute;
            margin-right: -2.87rem;
            right: 50%;
        }

        .start-btn {
            width: 3.06rem;
            display: block;
            position: absolute;
            left: 50%;
            margin-left: -1.53rem;
            bottom: 2rem;
        }


    }
    .start-animation .start-top {
        display: block;
        -webkit-animation: outUp .6s 2.9s both 1;
    }

    .start-animation .start-bottom {
        display: block;
        -webkit-animation: outDown .6s 2.9s both 1;
    }

    .start-animation .start-title {
        -webkit-animation: titleOutUp 1s 2.3s both 1;
    }

    .start-animation .start-left-line {
        -webkit-animation: fadeOutLeft .5s 2s both 1;
    }

    .start-animation .start-right-line {
        -webkit-animation: fadeOutRight .5s 2s both 1;
    }

    .start-animation .start-info {
        -webkit-animation: infoOutDown 1s 2.3s both 1;
    }

    .start-animation .start-btn {
        -webkit-animation: btnPulse 2.1s .3s both 1;
    }

    .isvipday-start-page {
        display: block;
    }



    @keyframes btnPulse {
        from {
            -webkit-transform: scale3d(1, 1, 1);
        }
        10% {
            -webkit-transform: scale3d(1.1, 1.1, 1.1);
        }
        30% {
            -webkit-transform: scale3d(1, 1, 1);
        }
        70% {
            opacity: 0.8;
        }
        90% {
            opacity: 0.5;
        }
        to {
            opacity: 0;
        }
    }

    @-webkit-keyframes infoOutDown {
        20% {
            -webkit-transform: translate3d(0, .2rem, 0);
        }

        40%, 45% {
            -webkit-transform: translate3d(0, .2rem, 0);
        }

        70% {
            -webkit-transform: translate3d(0, 6rem, 0);
        }
        to {
            opacity: 0;
            -webkit-transform: translate3d(0, 20rem, 0);
        }
    }

    @-webkit-keyframes titleOutUp {
        20% {
            -webkit-transform: translate3d(0, -.2rem, 0);
        }
        40%, 45% {
            -webkit-transform: translate3d(0, .2rem, 0);
        }
        70% {
            -webkit-transform: translate3d(0, -6rem, 0);
        }
        to {
            opacity: 0;
            -webkit-transform: translate3d(0, -20rem, 0);
        }
    }

    @-webkit-keyframes fadeOutLeft {
        from {
            opacity: 1;
        }

        to {
            opacity: 0;
            -webkit-transform: translate3d(-100%, 0, 0);
        }
    }

    @-webkit-keyframes fadeOutRight {
        from {
            opacity: 1;
        }

        to {
            opacity: 0;
            -webkit-transform: translate3d(100%, 0, 0);
            transform: translate3d(100%, 0, 0);
        }
    }

    @-webkit-keyframes outUp {
        from {
            -webkit-transform: translate3d(0, 0, 0);
        }
        50% {
            -webkit-transform: translate3d(0, -1rem, 0);
        }
        to {

            -webkit-transform: translate3d(0, -20rem, 0);
        }
    }

    @-webkit-keyframes outDown {
        from {
            -webkit-transform: translate3d(0, 0, 0);
        }
        50% {
            -webkit-transform: translate3d(0, 1rem, 0);
        }
        to {

            -webkit-transform: translate3d(0, 20rem, 0);
        }
    }


</style>


// WEBPACK FOOTER //
// src/pages/index/component/vip_day.vue